// src/pages/user/components/details/Details.tsx
import React from 'react'
import classes from './Details.module.sass'
import { ExecutorClusterResponse } from '../../../../../../common/types/interfaces'

type Props = {
  cluster: ExecutorClusterResponse | null
}

export const Details: React.FC<Props> = ({ cluster }) => {
  if (!cluster) return null

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.title}>Информация о кластере</div>

        <div className={classes.row}>
          <div className={classes.item}>
            <div className={classes.label}>Название</div>
            <div className={classes.value}>{cluster.cluster.name}</div>
          </div>
          <div className={classes.item}>
            <div className={classes.label}>Домен</div>
            <div className={classes.value}>{cluster.cluster.domain}</div>
          </div>
        </div>

        <div className={classes.row}>
          <div className={classes.item}>
            <div className={classes.label}>Статус кластера</div>
            <div className={classes.value}>
              {cluster.cluster.isActive ? '✅ Активен' : '❌ Неактивен'}
            </div>
          </div>
          <div className={classes.item}>
            <div className={classes.label}>Роль</div>
            <div className={classes.value}>
              {cluster.canServe ? '🛎️ Обслуживает' : '❌ Не обслуживает'}
            </div>
          </div>
        </div>

        <div className={classes.row}>
          <div className={classes.item}>
            <div className={classes.label}>Исполнитель</div>
            <div className={classes.value}>{cluster.executorName}</div>
          </div>
          <div className={classes.item}>
            <div className={classes.label}>Статус исполнителя</div>
            <div className={classes.value}>
              {cluster.isActive ? '✅ Активен' : '❌ Неактивен'}
            </div>
          </div>
        </div>

        {cluster.position && (
          <div className={classes.row}>
            <div className={classes.item}>
              <div className={classes.label}>Позиция</div>
              <div className={classes.value}>{cluster.position}</div>
            </div>
          </div>
        )}

        <div className={classes.row}>
          <div className={classes.item}>
            <div className={classes.label}>Токен</div>
            <div className={classes.token}>{cluster.cluster.token}</div>
          </div>
        </div>
      </div>
    </div>
  )
}